module.exports = __webpack_public_path__ + "static/img/gglrxc.3d44fa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/gglrxc.svg
// module id = fDgM
// module chunks = 0